import { Swiper } from 'swiper';
import { A11y, Autoplay, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper/modules';
if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }
  }
  customElements.define('product-info', ProductInfo);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.initElements();
    this.bindEvents();
    this.initObserver();

    this.addEventListener('click', this.handleClick);
  }

  initElements() {
    this.addToCart = this.querySelector('[data-sticky-add-to-cart]');
    this.productForm = document.querySelector('product-info product-form');
    this.footer = document.querySelector('[data-main-footer]');
    this.announcementBar = document.querySelector('.announcement-bar');
  }

  bindEvents() {
    if (this.addToCart) {
      this.addToCart.addEventListener('click', (e) => {
        this.productForm.onSubmitHandler(e);
      });
    }
  }

  initObserver() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this));

      if (this.productForm instanceof Element) {
        this.observer.observe(this.productForm);
      }

      if (this.footer instanceof Element) {
        this.observer.observe(this.footer);
      }

      if (this.announcementBar instanceof Element) {
        this.observer.observe(this.announcementBar);
      }
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (
        entry.target === this.footer ||
        entry.target === this.productForm ||
        entry.target === this.announcementBar
      ) {
        entry.isIntersecting
          ? this.classList.add('sticky-atc-hidden')
          : this.classList.remove('sticky-atc-hidden');
      } else {
        !entry.isIntersecting
          ? this.classList.add('!translate-x-0')
          : this.classList.remove('!translate-x-0');
      }
    });
  }

  handleClick() {
    this.classList.contains('sticky-atc-hidden') && this.classList.remove('sticky-atc-hidden');
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}

const stl_init = () => {
  const stl__products_container = document.querySelector('.stl__products_container');

  if (!stl__products_container) return false;

  if (!Swiper) {
    return false;
  }

  stl__products_container.classList.add('swiper', 'pb-12');

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  [...stl__products_container.children].forEach((child) => {
      child.classList.add('swiper-slide');
      wrapper.appendChild(child);
  });

  stl__products_container.appendChild(wrapper);

  let pagination = stl__products_container.querySelector('.swiper-pagination');

  if (!pagination) {
    pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';

    const wrapper = stl__products_container.querySelector('.swiper-wrapper');

    // Insert after wrapper (outside it)
    wrapper.insertAdjacentElement('afterend', pagination);
  }

  const swiperSTLOptions = {
    modules: [A11y, Autoplay, Navigation, Pagination, Scrollbar],
    threshold: 10,
    spaceBetween: 8,
    direction: 'horizontal',
    slidesPerView: 1.1,
    watchSlidesProgress: true,
    pagination: {
      el: pagination,
      clickable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 1.2,
      },
    },
  };

  try {
    const swiper = new Swiper(stl__products_container, swiperSTLOptions);
    console.log(swiper);
  } catch (e) {
    console.error(e);
  }
  return true;
};

if (!stl_init()) {
  const observer = new MutationObserver(() => {
    if (stl_init()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
